const ENDPOINT = {
  BOOKING: 'forwarder_manage_reservation.htm',
};

const TRACKING = 'BOOKING_QUERY';

export { ENDPOINT, TRACKING };
